module.exports = __webpack_public_path__ + "img/hs_logo_lv.b4215db3.png";